export const USER_AUTHENTICATION_UPDATE = 'session/USER_AUTHENTICATION_UPDATE';
export const USER_LOGGED_OUT = 'session/USER_LOGGED_OUT';



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/session/session.action.const.ts